module.exports = __webpack_public_path__ + "img/AdobeStock_348345239.f3618b20.jpeg";